/* apps/landing/src/index.css — geteiltes Tailwind-v4-Theme + @source für @repo/ui.
   Die eigene src wird vom @tailwindcss/vite-Plugin automatisch gescannt. */
@import "@repo/config/globals.css";

@source "../../../packages/ui/src";

/* Landing-eigene Töne: die Seite läuft auf den Theme-Tokens (hell/dunkel),
   aber Speisekarte + Telefon sind bewusst PAPIER — eine Karte ist ein
   physisches Objekt und bleibt auch im Dark Mode hell. `ink` ist die
   dazugehörige Schriftfarbe, `copper` der Akzent (Preise, Eyebrow, Ziffern),
   `pine` das Flaschengrün auf Papierflächen. */
/* Display-Schrift der Landing: das geteilte Theme reicht --font-display per
   `@theme inline` durch — überschrieben wird die :root-Variable, NICHT der
   @theme-Block (dort gewönne die Definition aus globals.css). */
:root {
  --font-display: "Fraunces", ui-serif, Georgia, serif;
}

@theme {
  --color-paper: oklch(0.97 0.016 85);
  --color-receipt: oklch(0.99 0.005 95);
  --color-paper-edge: oklch(0.88 0.025 80);
  --color-ink: oklch(0.3 0.02 60);
  --color-ink-soft: oklch(0.48 0.02 60);
  --color-pine: oklch(0.42 0.07 165);
  --color-copper: oklch(0.58 0.11 55);

  /* Lade-Sequenz im Hero (Utilities `animate-rise`/`animate-rise-late`;
     Reduced Motion über die `motion-reduce:animate-none`-Variante am Element). */
  --animate-rise: landing-rise 0.6s ease-out both;
  --animate-rise-late: landing-rise 0.6s 0.18s ease-out both;
  @keyframes landing-rise {
    from {
      opacity: 0;
      transform: translateY(14px);
    }
    to {
      opacity: 1;
      transform: none;
    }
  }
}

/* Kassenbon („Die Rechnung, bitte"): bewusst Thermopapier statt noch einer
   Speisekarten-Karte. Die Abriss-Zacken oben/unten entstehen per
   conic-gradient-Maske — der Schatten muss deshalb als drop-shadow auf dem
   WRAPPER liegen (box-shadow würde mit weggeschnitten; drop-shadow folgt
   sogar den Zacken). */
.receipt {
  --zack: 14px;
  background: var(--color-receipt);
  mask:
    conic-gradient(from 135deg at top, #0000, #000 1deg 89deg, #0000 90deg)
      top / var(--zack) 51% repeat-x,
    conic-gradient(from -45deg at bottom, #0000, #000 1deg 89deg, #0000 90deg)
      bottom / var(--zack) 51% repeat-x;
}
